class carouselTabList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tablist = document.querySelector('.tablist');
    this.tabs = document.querySelectorAll('.tab:not([disabled="true"])');
    this.tabpanels = document.querySelectorAll('.tabpanel');

    if (!this.tablist || !this.tabs.length || !this.tabpanels.length) {
      console.error('Error: Tabs or tablist not found.');
      return;
    }

    this.tablist.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowLeft':
          this.selectPreviousTab();
          break;
        case 'ArrowRight':
          this.selectNextTab();
          break;
        case 'Home':
          e.preventDefault();
          this.selectFirstTab();
          break;
        case 'End':
          e.preventDefault();
          this.selectLastTab();
          break;
      }
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        const nextTabIndex = Array.prototype.slice.call(this.tabs).indexOf(e.target);
        this.selectTab(nextTabIndex);

        document.querySelectorAll('product-tab-carousel').forEach((carousel) => {
          carousel.resetCarousel();
        });
      });
    });
  }

  selectPreviousTab() {
    const activeTab = document.querySelector('.tab[aria-selected="true"]');
    const activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);

    if (activeTabIndex > 0) {
      this.selectTab(activeTabIndex - 1);
    } else {
      this.selectTab(this.tabs.length - 1);
    }
  }

  selectNextTab() {
    const activeTab = document.querySelector('.tab[aria-selected="true"]');
    const activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);

    if (activeTabIndex < this.tabs.length - 1) {
      this.selectTab(activeTabIndex + 1);
    } else {
      this.selectTab(0);
    }
  }

  selectFirstTab() {
    this.selectTab(0);
  }

  selectLastTab() {
    this.selectTab(this.tabs.length - 1);
  }

  selectTab(index) {
    if (!this.tabs[index]) return;

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
      tab.setAttribute('tabindex', -1);
      tab.classList.remove('active');
    });

    this.tabs[index].setAttribute('aria-selected', true);
    this.tabs[index].setAttribute('tabindex', 0);
    this.tabs[index].classList.add('active');
    this.tabs[index].focus();

    this.tabpanels.forEach((tabpanel) => {
      tabpanel.classList.remove('block');
      tabpanel.classList.add('hidden');
    });

    const nextTabpanel = document.querySelector(`#${this.tabs[index].getAttribute('aria-controls')}`);
    if (nextTabpanel) {
      nextTabpanel.classList.add('block');
      nextTabpanel.classList.remove('hidden');
    }
  }
}

customElements.define('carousel-tab-list', carouselTabList);
